import { lang } from './store.js';
import { detectedLang } from './detectedLang.js';
import {wrap} from 'svelte-spa-router/wrap';
import Qrcode from './Qrcode.svelte';
import Wristband from './Wristband.svelte';
import NotFound from './NotFound.svelte';
import Home from './Home.svelte';

let langs = ['En', 'Fr', 'He', 'Ar', 'Ru', 'Es'];

if (langs[detectedLang] != 'undefined') {
    lang.set(detectedLang);
    //console.log('2:' + detectedLanguage);
}


export default  {
    '/':  Qrcode,
    '/home': Home,
    '/:id': Wristband,
    '*': NotFound,
}
